import {readAddress} from './address.serializer';
import User from '../models/user.model';


/**
 * Read a user object received from the backend.
 * @param {object} o
 * @return {User}
 */
function readUser(o) {
  const address = readAddress(o).makeImmutable();

  const u = new User(
    o.id,
    o.first_name,
    o.last_name,
    o.email,
    o.phone_number,
    o.other_phone_number,
    address,
    o.marketing_consent_entry,
    o.medical_marketing_consent_entry,
    o.medical_data_sharing,
    o.is_registered,
    o.is_valid,
    o.favourite_doctors,
    o.gender,
    o.birth_year,
    o.favourite_locations,
    o.unanswered_contact_questions,
  );

  u.inform_consent = 'inform_consent' in o? o.inform_consent : null;

  return u;
}

/**
 * Return a representation of a user object that can be sent to the backend.
 * @param {User} u
 * @returns {object}
 */
function writeUser(u) {
  return {
    first_name: u.first_name,
    last_name: u.last_name,
    email: u.email,
    phone_number: u.phone_number,
    other_phone_number: u.other_phone_number,
    postal_address: u.address.street,
    postal_code: u.address.postal_code,
    postal_area: u.address.postal_area,
    marketing_consent_entry: u.marketing_consent_entry,
    medical_marketing_consent_entry: u.medical_marketing_consent_entry,
    medical_data_sharing: u.medical_data_sharing,
    inform_consent: u.inform_consent != null? u.inform_consent : false,
  };
}

export {
  readUser,
  writeUser
};
